import { Role } from '../../types';
import { Permissions, PermissionVariant } from './mobileUsersPermissionsSelectorReducer';

// TO DO: Add new flags - CHINO 17/Jul/2025
export const permissionsByType = {
  basicBackend: ['answers', 'chat', 'tasks', 'assigned'],
  basicFrontend: ['viewFormAnswers', 'chat', 'submitFormAnswers', 'viewAssignedForms'],
  advancedBackend: [
    'evaluate',
    'metadata',
    'modify',
    'edit_forms',
    'evaluate_delete',
    'access_to_charts',
    'assign_new_places',
  ],
  advancedFrontend: [
    'changeFormStatus',
    'createMetadata',
    'editFormAnswers',
    'editForms',
    'evaluateDelete',
    'accessToCharts',
    'assignNewPlaces',
  ],
  adminBackend: [
    'users',
    'export',
    'admin_account_config',
    'admin_signatures',
    'admin_findings',
    'admin_assets',
    'admin_places',
  ],
  adminFrontend: [
    'viewAndCreateUsers',
    'exportData',
    'adminAccountConfig',
    'adminSignatures',
    'adminFindings',
    'adminAssets',
    'adminPlaces',
  ],
};

export const renamePermissions: { [key: string]: string } = {
  answers: 'viewFormAnswers',
  chat: 'chat',
  tasks: 'submitFormAnswers',
  assigned: 'viewAssignedForms',
  evaluate: 'changeFormStatus',
  metadata: 'createMetadata',
  modify: 'editFormAnswers',
  edit_forms: 'editForms',
  evaluate_delete: 'evaluateDelete',
  access_to_charts: 'accessToCharts',
  assign_new_places: 'assignNewPlaces',
  users: 'viewAndCreateUsers',
  export: 'exportData',
  admin_account_config: 'adminAccountConfig',
  admin_signatures: 'adminSignatures',
  admin_findings: 'adminFindings',
  admin_assets: 'adminAssets',
  admin_places: 'adminPlaces',
};

// TO DO: Add new flags - CHINO 14/Jul/2025
export const rolePermissions: Record<Role, Record<PermissionVariant, Permissions>> = {
  ADMINISTRATOR: {
    basic: {
      viewFormAnswers: true,
      chat: true,
      submitFormAnswers: true,
      viewAssignedForms: true,
    },
    advanced: {
      changeFormStatus: true,
      createMetadata: true,
      editFormAnswers: true,
      editForms: true,
      evaluateDelete: true,
      accessToCharts: true,
      assignNewPlaces: true,
    },
    admin: {
      viewAndCreateUsers: true,
      exportData: true,
      adminAccountConfig: true,
      adminSignatures: true,
      adminFindings: true,
      adminAssets: true,
      adminPlaces: true,
    },
  },

  SUPERVISOR: {
    basic: {
      viewFormAnswers: true,
      chat: true,
      submitFormAnswers: true,
      viewAssignedForms: true,
    },
    advanced: {
      changeFormStatus: true,
      createMetadata: true,
      editFormAnswers: true,
      editForms: false,
      evaluateDelete: true,
      accessToCharts: true,
      assignNewPlaces: true,
    },
    admin: {
      viewAndCreateUsers: false,
      exportData: true,
      adminAccountConfig: false,
      adminSignatures: false,
      adminFindings: false,
      adminAssets: false,
      adminPlaces: false,
    },
  },

  EDITING_OPERATOR: {
    basic: {
      viewFormAnswers: true,
      chat: true,
      submitFormAnswers: true,
      viewAssignedForms: true,
    },
    advanced: {
      changeFormStatus: false,
      createMetadata: false,
      editFormAnswers: true,
      editForms: false,
      evaluateDelete: false,
      accessToCharts: false,
      assignNewPlaces: false,
    },
    admin: {
      viewAndCreateUsers: false,
      exportData: false,
      adminAccountConfig: false,
      adminSignatures: false,
      adminFindings: false,
      adminAssets: false,
      adminPlaces: false,
    },
  },

  OPERATOR: {
    basic: {
      viewFormAnswers: false,
      chat: true,
      submitFormAnswers: true,
      viewAssignedForms: true,
    },
    advanced: {
      changeFormStatus: false,
      createMetadata: false,
      editFormAnswers: false,
      editForms: false,
      evaluateDelete: false,
      accessToCharts: false,
      assignNewPlaces: false,
    },
    admin: {
      viewAndCreateUsers: false,
      exportData: false,
      adminAccountConfig: false,
      adminSignatures: false,
      adminFindings: false,
      adminAssets: false,
      adminPlaces: false,
    },
  },
};

export const rolePermissionsList = Object.keys(rolePermissions) as Array<
  keyof typeof rolePermissions
>;
